import { ResourcesTabSidebar, ResourcesTab, getResourcesLinks } from '../../src';

export { ResourcesTabSidebar, getResourcesLinks };
export default ResourcesTab;
